<template lang="pug">
  component.flex(
    v-if="id"
    :is="isLink ? 'nuxt-link' : 'span'"
    :to="{ name: 'vendors-settings-subscription' }")
    img.img(
      v-if="SUBSCRIPTION_PLAN_IDS.FREE !== id"
      :src="badgeSrc" width="100" height="24")
</template>

<script>

import { mapGetters } from 'vuex'
import { kebabcase } from 'lodash'
import { SUBSCRIPTION_PLAN_IDS } from '~/settings'

export default {
  name: 'SubscriptionTag',

  props: {
    isLink: {
      type: Boolean,
      default: false
    },
    id: {
      type: Number,
      default: null
    }
  },

  computed: {
    SUBSCRIPTION_PLAN_IDS () {
      return SUBSCRIPTION_PLAN_IDS
    },
    ...mapGetters({
      vendorSubscriptionPlans: 'master/vendorSubscriptionPlans'
    }),
    badgeSrc () {
      const plan = this.vendorSubscriptionPlans.find(e => e.id === this.id) || {}

      return `/img/pod-subcription/badge.${kebabcase(plan.name)}.png?v1`
    }
  }
}
</script>

<style lang="scss" scoped>
.img {
  height: auto;
  width: 100px;
}
</style>
